module.exports = __webpack_public_path__ + "img/icon_w4m.09255b59.png";